import React from "react";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment-timezone";
import 'bootstrap-daterangepicker/daterangepicker.css';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
export function DateRangPickerForDashboard({ ...props }) {

  const UpdateValue = (start, end, label) => {
    console.log(start, end, label, 'smakmsak');
    const range = {
      from: start,
      to: end
    };
    if(props.onDateChange) {
      props.onDateChange(range)
    }
  }
  return (
    <>
      {props.label && <label className={props.isRequired ? 'required' : ''}>{props.label}</label>}
      <DateRangePicker
        initialSettings={{
          startDate: props.dateRange.from.toDate(),
          endDate: props.dateRange.to.toDate(),
          ranges: {
            Today: [moment().toDate(), moment().toDate()],
            Yesterday: [
              moment().subtract(1, 'days').toDate(),
              moment().subtract(1, 'days').toDate(),
            ],
            'Last 7 Days': [
              moment().subtract(6, 'days').toDate(),
              moment().toDate(),
            ],
            'Last 14 Days': [
              moment().subtract(13, 'days').toDate(),
              moment().toDate(),
            ],
            'Last 30 Days': [
              moment().subtract(29, 'days').toDate(),
              moment().toDate(),
            ],
            'This Month': [
              moment().startOf('month').toDate(),
              moment().endOf('month').toDate(),
            ],
            'Last Month': [
              moment().subtract(1, 'month').startOf('month').toDate(),
              moment().subtract(1, 'month').endOf('month').toDate(),
            ],
            'Last 2 Month': [
              moment().subtract(2, 'month').startOf('month').toDate(),
              moment().subtract(1, 'month').endOf('month').toDate(),
            ],
            'Last 6 Month': [
              moment().subtract(6, 'month').startOf('month').toDate(),
              moment().subtract(1, 'month').endOf('month').toDate(),
            ],
          },
        }}
        onCallback={UpdateValue}>
        <div className="c-pointer svg-icon text-hover-primary text-primary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Text/Filter.svg")} />
        </div>
        {/* <input type="text" name="daterange" className="form-control" /> */}
      </DateRangePicker>
    </>
  );
}
